<template>
  <div class="">
    <nav class="navbar navbar-default">
      <div class="container-fluid">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <!-- <a class="navbar-brand" href="index.html"><img src="../../assets/images/logo.png" class="img-responsive"></a> -->
          <a class="navbar-brand" href="" @click.prevent><img :src="logoUrl || ''" class="img-responsive"></a>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav client-navbar-nav navbar-nav navbar-right">
            <li><router-link :to="{ name: 'ClientDashboard'}">Home</router-link></li>
            <li><router-link :to="{ name: 'EarnPoints'}">Earn Points</router-link></li>
            <li><a @click.prevent="goCatalog" class="clickable">Redeem Points</a></li>
            <li><a @click.prevent="goCart" class="clickable">My Cart</a></li>
            <li><router-link :to="{ name: 'RulesAndTerms'}">{{ hasRules ? 'Rules/' : '' }}Terms &amp; Conditions</router-link></li>
            <li><router-link :to="{ name: 'Account'}">My Account</router-link></li>
            <li><a href="#" @click.prevent="logout">Logout</a></li>
          </ul>
        </div><!-- /.navbar-collapse -->
      </div><!-- /.container-fluid -->
    </nav>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('loyaltyProgram', {
      logoUrl: state => state.program.company ? state.program.company.logo.url : '',
      hasRules: state => state.program.rules !== ''
    })
  },
  methods: {
    logout () {
      localStorage.removeItem('jwtToken')
      localStorage.removeItem('user')
      this.$router.push({
        name: 'ClientLogin'
      })
    },
    // Navigation methods since routing to the same component
    goCatalog () {
      this.$router.push(
        {
          name: 'RedeemPoints',
          params: { initComponent: 'reward-catalog', updateKey: Math.random() }
        },
        null,
        () => {
          this.$bus.emit('reloadComponent', { comp: 'reward-catalog' })
        }
      )
    },
    goCart () {
      this.$router.push(
        {
          name: 'RedeemPoints',
          params: { initComponent: 'cart-items', updateKey: Math.random() }
        },
        null,
        () => {
          this.$bus.emit('reloadComponent', { comp: 'cart-items' })
        }
      )
    }
  }
}
</script>
